import React, { useEffect, useCallback } from "react";
import { withStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import Archive from "@mui/icons-material/Archive";
import Info from "@mui/icons-material/Info";

import { withState } from "../../../services/state";
import {
  getEvents as apiGetEvents,
  deleteEvent as apiDeleteEvent,
  archiveEvent as apiArchiveEvent,
} from "../../../services/api";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
import DialogModal from "../../components/dialogModal/DialogModal";
import YesNoDialogModal from "../../components/yesNoDialogModal/YesNoDialogModal";
import Section from "../../components/section/Section";
import Event from "../../components/event/Event";
import Button from "../../components/button/Button";
import PaymentDialogWrapper from "../../components/paymentDialog/PaymentDialogWrapper";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  eventHeader: {
    backgroundColor: "#c13535",
    color: "#fff",
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  infoClick: {
    marginLeft: 5,
    cursor: "pointer",
  },
  eventsButtons: {
    padding: 20,
    textAlign: "right",
  },
});

const event_info = {
  player:
    "This is a list of all events you've been added to and need to pay for. To pay for an unpaid event, simply tap an event to view full team details.",
};

const no_events = {
  player:
    "There are no events scheduled at the moment. We will send you an email when you have been selected for an event you need to pay for.",
};

function EventsPage({ dispatch, context }) {
  const [gettingEvents, setGettingEvents] = React.useState(false);
  const [events, setEvents] = React.useState([]);
  const [showDeleteEvent, setDeleteEvent] = React.useState(null);
  const [deletingEvent, setDeletingEvent] = React.useState(false);
  const [deleteEventError, setDeleteEventError] = React.useState("");
  const [showArchiveEvent, setArchiveEvent] = React.useState(null);
  const [archivingEvent, setArchivingEvent] = React.useState(false);
  const [archiveEventError, setArchiveEventError] = React.useState("");
  const [payEventFee, setPayEventFee] = React.useState(null);
  const [showEventsInfo, setShowEventsInfo] = React.useState(null);

  const getEvents = useCallback(async () => {
    if (
      !context.currentClub ||
      !context.currentClub.clubId ||
      !context.currentPlayer ||
      !context.currentPlayer.id
    ) {
      return false;
    }

    try {
      setGettingEvents(true);
      const data = await apiGetEvents(
        context.currentClub.clubId,
        context.currentPlayer.id,
      );
      if (data && !data.reason) {
        setEvents(data);
      }
      setGettingEvents(false);
    } catch (e) {
      console.log(e);
      setGettingEvents(false);
    }
  }, [context.currentClub, context.currentPlayer]);

  const deleteEvent = async () => {
    try {
      setDeletingEvent(true);
      await apiDeleteEvent(showDeleteEvent.id);
      setDeletingEvent(false);
      setDeleteEvent(null);
      getEvents();
    } catch (e) {
      setDeletingEvent(false);
      setDeleteEventError(e.message);
    }
  };

  const archiveEvent = async () => {
    try {
      setArchivingEvent(true);
      await apiArchiveEvent({ eventId: showArchiveEvent.id, view: "player" });
      setArchivingEvent(null);
      setArchiveEvent(null);
      getEvents();
    } catch (e) {
      console.log(e);
      setArchivingEvent(false);
      setArchiveEventError(e.message);
    }
  };

  const payForEvent = async (event) => {
    const myPlayer = event.currentPlayerFee;
    if (myPlayer && myPlayer.currentFee > 0 && !myPlayer.isPaid) {
      setPayEventFee({ ...myPlayer, eventGuid: event.guid });
    }
  };

  const failedPaymentEvents = events
    ? events?.filter((event) => {
        return (
          event.isConfirmed &&
          event.currentPlayerFee &&
          event.currentPlayerFee.failedAt &&
          event.currentPlayerFee.currentFee > 0
        );
      })
    : [];

  const unpaidEvents = events
    ? events
        .filter((event) => {
          if (context.currentClub.isTreasurer) {
            return !event.hideForTreasurers;
          } else if (event.isCaptainForEventTeam) {
            return !event.hideForCaptains;
          } else {
            return !event.hideForPlayer;
          }
        })
        .filter((event) => {
          return (
            event.isConfirmed &&
            event.currentPlayerFee &&
            !event.currentPlayerFee.submittedAt &&
            !event.currentPlayerFee.failedAt &&
            !event.currentPlayerFee.isPaid &&
            event.currentPlayerFee.currentFee > 0
          );
        })
    : [];

  const paymentSubmittedEvents = events
    ? events
        ?.filter((event) => {
          if (context.currentClub.isTreasurer) {
            // return event.hideForTreasurers && event.isConfirmed && event.currentPlayerFee && (event.currentPlayerFee.isPaid || event.currentPlayerFee.currentFee === 0);
            return !event.hideForTreasurers;
          } else if (event.isCaptainForEventTeam) {
            // return event.hideForCaptains && event.isConfirmed && event.currentPlayerFee && (event.currentPlayerFee.isPaid || event.currentPlayerFee.currentFee === 0);
            return !event.hideForCaptains;
          } else {
            return !event.hideForPlayer;
          }
        })
        .filter((event) => {
          return (
            !event.hideForPlayer &&
            event.isConfirmed &&
            event.currentPlayerFee &&
            event.currentPlayerFee.submittedAt &&
            !event.currentPlayerFee.isPaid &&
            event.currentPlayerFee.currentFee > 0
          );
        })
    : [];

  const paidEvents = events
    ? events
        .filter((event) => {
          if (context.currentClub.isTreasurer) {
            // return event.hideForTreasurers && event.isConfirmed && event.currentPlayerFee && (event.currentPlayerFee.isPaid || event.currentPlayerFee.currentFee === 0);
            return !event.hideForTreasurers;
          } else if (event.isCaptainForEventTeam) {
            // return event.hideForCaptains && event.isConfirmed && event.currentPlayerFee && (event.currentPlayerFee.isPaid || event.currentPlayerFee.currentFee === 0);
            return !event.hideForCaptains;
          } else {
            return !event.hideForPlayer;
          }
        })
        .filter((event) => {
          return (
            !event.hideForPlayer &&
            event.isConfirmed &&
            event.currentPlayerFee &&
            (event.currentPlayerFee.isPaid ||
              event.currentPlayerFee.currentFee === 0)
          );
        })
    : [];

  const renderFailedEvents = () => {
    if (failedPaymentEvents && failedPaymentEvents.length > 0) {
      return (
        <div>
          <EventHeader title="Failed Payments" backgroundColor="#b82828" />
          <div>
            {failedPaymentEvents.map((failedPaymentEvent) => {
              let borderColor = "transparent";
              let actionButton = null;
              actionButton = (
                <Button
                  onClick={() => payForEvent(failedPaymentEvent)}
                  title="Pay"
                />
              );
              return (
                <Event
                  key={failedPaymentEvent.id}
                  to={`/events/${failedPaymentEvent.id}`}
                  event={failedPaymentEvent}
                  actionButton={actionButton}
                  borderColor={borderColor}
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  const renderUnpaidEvents = () => {
    if (unpaidEvents && unpaidEvents.length > 0) {
      return (
        <div>
          <EventHeader title="You Need To Pay" backgroundColor="#c37b15" />
          <div>
            {unpaidEvents.map((unpaidEvent) => {
              let borderColor = "transparent";
              let actionButton = null;
              actionButton = (
                <Button
                  onClick={() => payForEvent(unpaidEvent)}
                  title="Pay"
                />
              );
              return (
                <Event
                  key={unpaidEvent.id}
                  to={`/events/${unpaidEvent.id}`}
                  event={unpaidEvent}
                  actionButton={actionButton}
                  borderColor={borderColor}
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  const renderPaymentSubmittedEvents = () => {
    if (paymentSubmittedEvents && paymentSubmittedEvents.length > 0) {
      return (
        <div>
          <EventHeader
            title="You've Submitted Payment"
            backgroundColor="#07843e"
          />
          <div>
            {paymentSubmittedEvents.map((paidEvent) => {
              let borderColor = "transparent";
              let actionButton = null;

              return (
                <Event
                  key={paidEvent.id}
                  to={`/events/${paidEvent.id}`}
                  event={paidEvent}
                  actionButton={actionButton}
                  borderColor={borderColor}
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  const renderPaidEvents = () => {
    if (paidEvents && paidEvents.length > 0) {
      return (
        <div>
          <EventHeader title="You've Paid" backgroundColor="#07843e" />
          <div>
            {paidEvents.map((paidEvent) => {
              let borderColor = "transparent";
              let actionButton = null;

              actionButton = (
                <Button
                  onClick={() => setArchiveEvent(paidEvent)}
                  title="Archive"
                />
              );
              return (
                <Event
                  key={paidEvent.id}
                  to={`/events/${paidEvent.id}`}
                  event={paidEvent}
                  actionButton={actionButton}
                  borderColor={borderColor}
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  return (
    <PageWrapper
      showHeader={true}
      showSidebar={true}
      title="Your Events"
      onInfoClick={event_info["player"] ? () => setShowEventsInfo(true) : null}
      rightContent={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Link to="/archive">
            <div
              style={{
                marginRight: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textDecorationLine: "none",
                color: "#000",
              }}
            >
              Archive
              <Archive
                style={{ color: "#000", fontSize: "30px", marginLeft: "5px" }}
              />
            </div>
          </Link>
        </div>
      }
    >
      <Section style={{ padding: 0, backgroundColor: "transparent" }}>
        <div>
          {renderFailedEvents()}
          {renderUnpaidEvents()}
          {renderPaymentSubmittedEvents()}
          {renderPaidEvents()}
          {!gettingEvents && events.length === 0 && (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              {no_events["player"]}
            </div>
          )}
        </div>
      </Section>

      {showDeleteEvent && (
        <YesNoDialogModal
          title="Are you sure you want to delete event?"
          onClose={() => setDeleteEvent(false)}
          onSubmit={() => deleteEvent()}
          submitting={deletingEvent}
          error={deleteEventError}
        />
      )}

      {showArchiveEvent && (
        <YesNoDialogModal
          title="Are you sure you want to archive event?"
          onClose={() => setArchiveEvent(false)}
          onSubmit={() => archiveEvent()}
          submitting={archivingEvent}
          error={archiveEventError}
        />
      )}

      {payEventFee && (
        <PaymentDialogWrapper
          eventFee={payEventFee}
          onClose={() => setPayEventFee(null)}
          onSuccess={() => {
            setPayEventFee(null);
            // Dispatch custom event to notify sidebar to refresh player data
            window.dispatchEvent(new CustomEvent('refreshPlayerNotifications'));
            getEvents();
          }}
          context={context}
        />
      )}

      {showEventsInfo && (
        <DialogModal
          title="Your events"
          onClose={() => setShowEventsInfo(null)}
          cancelText="Close"
        >
          <div>{event_info["player"]}</div>
        </DialogModal>
      )}
    </PageWrapper>
  );
}

const EventHeader = withStyles(styles)(({
  title,
  classes,
  onInfoClick,
  backgroundColor,
}) => {
  return (
    <div
      className={classes.eventHeader}
      style={{ backgroundColor: backgroundColor || "transparent" }}
    >
      {title}
      {onInfoClick && (
        <div className={classes.infoClick} onClick={() => onInfoClick()}>
          <Info />
        </div>
      )}
    </div>
  );
});

export default withStyles(styles)(withState(EventsPage));
